import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { colors } from "../../styles/theme";
import { useDeviceStyles } from "../../hooks/useDeviceStyles";

type DropdownRenderProps = {
  close: () => void;
};

type DropdownBrandLinkProps = {
  trigger: (props: {
    open: boolean;
    toggle: () => void;
    close: () => void;
  }) => React.ReactNode;
  menu: (props: DropdownRenderProps) => React.ReactNode;
  placement?: "left" | "right";
  offsetY?: number;
  minWidth?: number;
};

export function DropdownBrandLink(props: DropdownBrandLinkProps) {
  const {
    trigger,
    menu,
    placement = "left",
    offsetY = 8,
    minWidth = 220,
  } = props;
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement | null>(null);
  const { isMobileDevice } = useDeviceStyles();

  const close = () => setOpen(false);
  const toggle = () => setOpen((v) => !v);

  // Close on outside click
  useEffect(() => {
    const onDown = (e: MouseEvent) => {
      if (!rootRef.current) return;
      if (!rootRef.current.contains(e.target as Node)) close();
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  // Close on Escape
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div ref={rootRef} style={{ position: "relative", display: "inline-block" }}>
      {trigger({ open, toggle, close })}

      {open && (
        <Box
          role="menu"
          sx={{
            position: "absolute",
            top: `calc(100% + ${offsetY}px)`,
            ...(placement === "left" ? { left: 0 } : { right: 0 }),
            minWidth,
            background: colors.background.v1,
            zIndex: 1000,
            padding: isMobileDevice ? '20px' : '10px',
          }}
        >
          {menu({ close })}
        </Box>
      )}
    </div>
  );
}
